import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Select, MenuItem, InputLabel, FormControl, Alert } from '@mui/material';
import { SizeDataTypeInterface } from '../../../interfaces/interfaces';

interface Props {
  open: boolean;
  sizeDataTypeToUpdate: SizeDataTypeInterface | null;
  setSizeDataTypeToUpdate: React.Dispatch<React.SetStateAction<SizeDataTypeInterface | null>>;
  onClose: () => void;
  onSave: () => void;
  updateError?: string | null;
  updateSuccess?: string | null;
}

export const AdSpaceSizeDataTypesUpdateDialog: React.FC<Props> = ({
  open,
  sizeDataTypeToUpdate,
  setSizeDataTypeToUpdate,
  onClose,
  onSave,
  updateError,
  updateSuccess,
}) => (
  <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
    <DialogTitle>Update Size Data Type</DialogTitle>
    <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
      {updateError && <Alert severity="error">{updateError}</Alert>}
      {updateSuccess && <Alert severity="success">{updateSuccess}</Alert>}
      <TextField
        label="Unit Name"
        value={sizeDataTypeToUpdate?.unitName ?? ''}
        onChange={e => setSizeDataTypeToUpdate(s => s ? { ...s, unitName: e.target.value } : s)}
        fullWidth
        margin="dense"
        required
      />
      <TextField
        label="Description"
        value={sizeDataTypeToUpdate?.description ?? ''}
        onChange={e => setSizeDataTypeToUpdate(s => s ? { ...s, description: e.target.value } : s)}
        fullWidth
        margin="dense"
      />
      <FormControl fullWidth margin="dense">
        <InputLabel id="active-label">Active</InputLabel>
        <Select
          labelId="active-label"
          value={sizeDataTypeToUpdate?.active !== undefined ? (sizeDataTypeToUpdate.active ? 'yes' : 'no') : 'yes'}
          label="Active"
          onChange={e => setSizeDataTypeToUpdate(s => s ? { ...s, active: e.target.value === 'yes' } : s)}
        >
          <MenuItem value="yes">Yes</MenuItem>
          <MenuItem value="no">No</MenuItem>
        </Select>
      </FormControl>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose}>Cancel</Button>
      <Button color="primary" onClick={onSave}>Save</Button>
    </DialogActions>
  </Dialog>
);